import React from "react";
import { useEffect } from "react";
import { MdDone } from "react-icons/md";
import Swal from "sweetalert2";
import { clearToken } from "../../helpers/utility";

const SuccessfullyUpgraded = () => {
    useEffect(() => {
        setTimeout(() => {
            Swal.fire({
                title: "Congratulations!",
                text: "Your account has been upgraded to PRO. You will be logged out.",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                showConfirmButton: false,
                cancelButtonText: "Close",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            }).then((x) => {
                if (x.isDismissed) {
                    clearToken();
                    document.location.href = "/";
                }
            });
        }, 2000);
    }, []);
    return (
        <div className="px-2 sm:px-4 lg:px-8 py-7 h-full overflow-hidden">
            <div className="bg-white w-full h-full flex justify-center items-center rounded-lg">
                <div className="min-w-[258px] max-w-[516px] mx-auto">
                    <div className="w-[74px] aspect-square rounded-full flex justify-center items-center border-4 border-orange-color mb-5 mx-auto">
                        <MdDone className="text-orange-color text-[40px]" />
                    </div>
                    <div className="mb-5 text-center">
                        <h3 className="text-xl sm:text-2xl font-bold text-ebony-color mb-2">
                            Welcome to PRO!
                        </h3>
                        <p className="text-sm sm:text-base font-medium text-black-60 ">
                            Your plan is successfuly upgraded, now enjoy the
                            benifits of VIP circle, 1080p video streaming,
                            Inmail feature and much more.
                        </p>
                    </div>
                    <button className="text-sm font-medium text-orange-color capitalize block mx-auto">
                        You will be logged out now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessfullyUpgraded;
